(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import axios from "../../../utils/axiosClient";
import createProvider from "../../../utils/provider";
import { normalizeHsCodes, normalizeHistory, normalizeCountries, normalizeHsCodeDetails } from "./normalize";

const getApiUrl = () => "".concat(axios.API_URL);

export const fetchHsCodes = createProvider(_ref => {
  let {
    countryCode,
    searchString
  } = _ref;
  return axios.get("".concat(getApiUrl(), "/search"), {
    params: {
      query: searchString
    },
    data: {},
    // need set empty data due to removing Content type from header by axios if data is empty
    headers: {
      tenantKey: countryCode
    }
  }).then(response => ({ ...response,
    data: normalizeHsCodes(response.data)
  }));
}, {
  cacheTime: 60000
});
export const fetchCountries = createProvider(() => axios.get("".concat(getApiUrl(), "/countries")).then(response => ({ ...response,
  data: normalizeCountries(response.data)
})), {
  cacheTime: 60000
});
export const fetchHistory = createProvider(() => axios.get("".concat(getApiUrl(), "/history")).then(response => ({ ...response,
  data: normalizeHistory(response.data)
})), {
  cacheTime: 15000
});
export const fetchHsCodeDetails = createProvider(_ref2 => {
  let {
    hsCode,
    countryCode
  } = _ref2;
  return axios.get("".concat(getApiUrl(), "/tree"), {
    params: {
      code: hsCode
    },
    data: {},
    // need set empty data due to removing Content type from header by axios if data is empty
    headers: {
      tenantKey: countryCode
    }
  }).then(response => ({ ...response,
    data: normalizeHsCodeDetails(response.data)
  }));
}, {
  cacheTime: 2000
});
export const fetchExplanatoryNotes = createProvider(_ref3 => {
  let {
    hsCode
  } = _ref3;
  return axios.get("https://declaire-static.s3.eu-central-1.amazonaws.com/explanatory_note_htmls/psn".concat(hsCode, ".html"), {
    data: {}
  });
}, {
  cacheTime: 2000
});
export const downloadSearchData = (value, code, language) => {
  const fileName = "".concat(value === "TariffBook" ? "" : "chapters/".concat(code, "_")).concat(value, "_bd.pdf");
  const a = document.createElement("a");
  a.href = "https://declaire-static.s3.eu-central-1.amazonaws.com/".concat(fileName);
  a.download = fileName;
  a.target = "_blank";
  a.click();
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getApiUrl, "getApiUrl", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/dataProvider.js");
  reactHotLoader.register(fetchHsCodes, "fetchHsCodes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/dataProvider.js");
  reactHotLoader.register(fetchCountries, "fetchCountries", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/dataProvider.js");
  reactHotLoader.register(fetchHistory, "fetchHistory", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/dataProvider.js");
  reactHotLoader.register(fetchHsCodeDetails, "fetchHsCodeDetails", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/dataProvider.js");
  reactHotLoader.register(fetchExplanatoryNotes, "fetchExplanatoryNotes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/dataProvider.js");
  reactHotLoader.register(downloadSearchData, "downloadSearchData", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/dataProvider.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();